import { Component, ElementRef, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { IDriverService, TaskService } from '../../../../services';
import { JobScreenDriverMessagesTask } from '../../../../interfaces/screen-specific/job-screen';
import { JobScreenCommonService } from '../job-screen-common.service';
import { Message } from '../../../../classes/Message';
import { MessageService } from 'primeng';

@Component({
  selector: 'job-screen-driver-messages',
  templateUrl: './job-screen-driver-messages.component.html',
  styleUrls: ['./job-screen-driver-messages.component.scss'],
})
export class JobScreenDriverMessagesComponent implements OnChanges {
  @Input() taskId!: number;
  @Input() jobId!: number;
  @Input() organisationTypeId!: number;

  @ViewChild('scrollAnchor') scrollAnchor!: ElementRef;
  @ViewChild('messageScroller') messageScroller!: ElementRef;

  smsMessage: string;
  isSendMessageToDriver: boolean;
  selectedTask: JobScreenDriverMessagesTask;
  isReloadDriverMessages: boolean;
  isBusySendMessageToDriver: boolean;

  constructor(
    private taskService: TaskService,
    private driverService: IDriverService,
    public commonServices: JobScreenCommonService,
    private messageService: MessageService,
  ) {}

  async ngOnChanges(changes: SimpleChanges) {
    if (changes.taskId) {
      this.fetchTask();
    }
  }

  private fetchTask() {
    this.taskService
      .getForComponent(this.taskId, 'job-screen-driver-messages')
      .then((task: JobScreenDriverMessagesTask) => {
        this.selectedTask = task;

        // Scroll the window down to the most recent message
        //        setTimeout(() => {
        //          this.messageScroller.nativeElement.scrollTop =
        //            this.messageScroller.nativeElement.scrollHeight;
        //        }, 10000);
      });
  }

  sendMessageToDriver() {
    if (!this.smsMessage || this.smsMessage.length == 0) {
      return;
    }
    this.isBusySendMessageToDriver = true;

    this.driverService
      .sendMessage(this.selectedTask.driverId, this.smsMessage, this.selectedTask.id)
      .then(() => {
        this.messageService.add(Message.Success('Message sent successfully', 'Success'));
        this.isBusySendMessageToDriver = false;
        this.isSendMessageToDriver = false;
        this.reloadDriverMessages(this.selectedTask.id);

        this.smsMessage = '';
      })
      .catch(() => {
        this.isBusySendMessageToDriver = false;
        this.messageService.add(
          Message.Error('An error occurred while trying to send the message', 'Error'),
        );
      });
  }

  reloadDriverMessages(taskId: number) {
    this.isReloadDriverMessages = true;

    this.taskService
      .getDriverMessages(taskId)
      .then((result) => {
        this.isReloadDriverMessages = false;
        this.selectedTask.driverMessages = result;
      })
      .catch(() => {
        this.isReloadDriverMessages = false;
        this.messageService.add(
          Message.Error(
            'An error occurred while updating the data. The current data may not be correct.',
            'Reload Driver Messages',
          ),
        );
      });
  }
}
